<template>
    <div class="kiaf-photo-tag-group" :class="{ 'is-show-breadcrumb': customize.showBreadcrumb }">


        <!-- 面包屑 -->
        <kc-breadcrumb class="tags-breadcrumb" v-if="customize.showBreadcrumb">
            <kc-breadcrumb-item>首页</kc-breadcrumb-item>
            <kc-breadcrumb-item
                    v-for="(item,index) in  $store.state.kiaf.breadCrumbList"
                    :key="index">
                {{item}}
            </kc-breadcrumb-item>
        </kc-breadcrumb>
        <div @click.prevent.stop="goForward()" class="go-forward-btn" v-if="visitedViews.length >= customize.visibleTagUpperLimit">
            <span><i class="kc-icon-arrow-left"></i></span>
        </div>
        <div ref="scrollPane" class="tags-view-wrapper" :class="{'tags-view-offset':visitedViews.length >= customize.visibleTagUpperLimit}">

            <div
                    v-for="(tag,index) in visitedViews"
                    ref="tag"
                    :class="isActive(tag)?'active':''"
                    :key="tag.id"
                    tag="span"
                    @click.prevent.stop="changePath(tag)"
                    class="tags-view-item">
                <span class="tags-view-txt" :title="tag.title">{{ tag.title }}</span>
                <span class="kc-icon-close" @click.prevent.stop="closeSelectedTag(tag,index)"></span>
            </div>
        </div>
        <div @click.prevent.stop="goBack()" class="go-back-btn" v-if="visitedViews.length >= customize.visibleTagUpperLimit">

            <span><i class="kc-icon-arrow-right"></i></span>
        </div>
    </div>
</template>

<script>
  import mixins from '../mixins';
  export default {
    mixins: [mixins],
    watch: {
      tagList(newVal) {
        if (newVal.length > this.customize.visibleTagUpperLimit) {
          this.visitedViews = newVal.slice(newVal.length - this.customize.visibleTagUpperLimit, newVal.length);
        } else {
          this.visitedViews = newVal;
        }
      },
      '$route': function () { //路由变化，改变面包屑
        let activeTag = this.getActiveTag();
        if (activeTag) {
          let {parentTitle = '', title = '', id = ''} = activeTag;
          this.$store.commit('KIAF_SET_MENUACTIVEINDEX', id);
          this.$store.commit('KIAF_SET_BREADCRUMB', [parentTitle, title]);
          if (this.tagList.length > this.customize.visibleTagUpperLimit) {
            let visitedFirstTagId = this.visitedViews[0].id;
            let visitedLastTagId = this.visitedViews[this.visitedViews.length - 1].id;
            let activeIndex = this.tagList.findIndex(tag => tag.id === id);
            let visitedFirstTagIndex = this.tagList.findIndex(tag => tag.id === visitedFirstTagId);
            let visitedLastTagIndex = this.tagList.findIndex(tag => tag.id === visitedLastTagId);
            if (activeIndex > -1) {
              if (activeIndex >= 0 && activeIndex < visitedFirstTagIndex) {
                for (let i = 0; i < (visitedFirstTagIndex - activeIndex); i++) {
                  this.goForward();
                }
              }
              if (activeIndex > visitedLastTagIndex) {
                for (let i = 0; i < (activeIndex - visitedLastTagIndex); i++) {
                  this.goBack();
                }
              }
            }
          }
        }
      }
    }
  };
</script>
<style lang="scss">
    @import "index.scss";
</style>
